module.exports = __webpack_public_path__ + "left.119ed749.png";